import fetch from '../../../../core/fetch';
import showToaster from '../../../../helpers/toasterMessages/showToaster';

async function submit(values, dispatch) {
  const query = `
  mutation (
    $aboutUsTitle: String,
    $aboutUsContent: String,
) {
  updateAboutUsPage (
    aboutUsTitle: $aboutUsTitle,
    aboutUsContent: $aboutUsContent,
  ) {
      status
  }
}

  `;

  const resp = await fetch('/graphql', {
    method: 'post',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      query: query,
      variables: values
    }),
    credentials: 'include',
  });

  const { data } = await resp.json();

  if (data.updateAboutUsPage.status === "success") {
    showToaster({ messageId: 'updateAboutUsPage', toasterType: 'success'})
  } else {
    showToaster({ messageId: 'updateAboutUsPageFailed', toasterType: 'error' })
  }

}

export default submit;
